import PropTypes from "prop-types";

import {
  style,
  lightDark,
} from "@react-spectrum/s2/style" with { type: "macro" };

/**
 * What covers a thumbnail while the user hovers it, to say what a click does:
 * a translucent layer with the `icon` in a rounded chip. Always rendered, and
 * faded in and out as the variation cards' hover is, so it never blocks the
 * thumbnail while it is invisible. `compact` is for small thumbnails, and
 * `radius` the corners of the layer (`"lg"`, or `"default"` for small ones).
 */
export const HoverOverlay = ({
  isHovered,
  icon: Icon,
  compact = false,
  radius = "lg",
}) => (
  <div
    aria-hidden
    className={style({
      boxSizing: "border-box",
      size: "full",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: lightDark("white/65", "black/65"),
      borderRadius: { default: "lg", isSmall: "default" },
      position: "absolute",
      inset: 0,
      pointerEvents: "none",
      opacity: { default: 0, isHovered: 1 },
      transition: "[all]",
      transitionDuration: 300,
      willChange: "[opacity]",
    })({ isHovered, isSmall: radius === "default" })}
  >
    <div
      className={style({
        backgroundColor: {
          default: "transparent-overlay-100",
        },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: { default: 16, isCompact: 4 },
        padding: { default: 8, isCompact: 4 },
        borderRadius: "default",
      })({ isCompact: compact })}
    >
      <Icon />
    </div>
  </div>
);

HoverOverlay.propTypes = {
  isHovered: PropTypes.bool,
  icon: PropTypes.elementType.isRequired,
  compact: PropTypes.bool,
  radius: PropTypes.oneOf(["lg", "default"]),
};
